import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';

import {
    useCheckerContext,
    checkTypes
} from 'client/components/infoDialog/ProviderFlowInfoAndActionChecker';

function MaskFlowInfoAndAction() {
    // as force update trigger
    const newReduxState = useSelector(s => s);
    const checkerApi = useCheckerContext();
    const [coverMask, setCoverMask] = useState(false);

    useEffect(() => {
        if (
            checkerApi.check(
                [checkTypes.LOGIN_STATUS, checkTypes.PROMO_STATUS, checkTypes.QUALIFY_STATUS],
                false
            )
        ) {
            setCoverMask(false);
        } else {
            setCoverMask(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newReduxState]);

    return (
        <div
            css={[maskStyle, coverMask && coverMaskStyle]}
            onClick={() =>
                checkerApi.check([
                    checkTypes.LOGIN_STATUS,
                    checkTypes.PROMO_STATUS,
                    checkTypes.QUALIFY_STATUS
                ])
            }
        />
    );
}

export default MaskFlowInfoAndAction;

const maskStyle = css`
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 5;
    cursor: pointer;
    pointer-events: none;
`;

const coverMaskStyle = css`
    pointer-events: auto;
`;
